export const issueStatusNodes = view => [
  view.state.schema.nodes.form_label.create({id: 'status'}, view.state.schema.text('Status')),
  view.state.schema.nodes.form_select.create({
    id: 'status',
    name: 'status',
    settings: {
      values: [
        {
          "name": "Open",
          "value": "Open",
          "selected": true
        },
        {
          "name": "In Progress",
          "value": "In Progress"
        },
        {
          "name": "Review",
          "value": "Review"
        },
        {
          "name": "Done",
          "value": "Done"
        },
        {
          "name": "Closed",
          "value": "Closed"
        }
      ]
    },
  })
];